import { createContext, type PropsWithChildren } from 'react';

import { UrlSearchStateProvider } from './UrlSearchStateProvider';
import { useTrackInitialSiteSearchEvent } from '../hooks/useTrackInitialSiteSearchEvent';
import { useSetSearchStateFromUrlOnMount } from '../hooks/useSetSearchStateFromUrlOnMount';
import { usePersistUserSearchDetails } from '../hooks/usePersistUserSearchDetails';
import { useOptionChangedEffect } from '../hooks/useOptionChangedEffect';
import { useFiltersChangeEffect } from '../hooks/useFiltersChangeEffect';
import { useAdjustScrollPosition } from '../hooks/useAdjustScrollPosition';

const SearchContext = createContext<null>(null);

const SearchEffects = ({ children }: PropsWithChildren) => {
  useSetSearchStateFromUrlOnMount();

  usePersistUserSearchDetails();

  useTrackInitialSiteSearchEvent();

  useAdjustScrollPosition();

  useFiltersChangeEffect();

  useOptionChangedEffect();

  return <SearchContext.Provider value={null}>{children}</SearchContext.Provider>;
};

export const SearchEffectsProvider = ({ children }: PropsWithChildren) => (
  <UrlSearchStateProvider>
    <SearchEffects>{children}</SearchEffects>
  </UrlSearchStateProvider>
);
